// extracted by mini-css-extract-plugin
module.exports = {"container":"NoTableData_container__1iGfa"};